import React, { useState } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import './SimpleInvoice.css';

function SimpleInvoice() {
  const [shopName, setShopName] = useState('');
  const [gstNumber, setGstNumber] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [itemName, setItemName] = useState('');
  const [price, setPrice] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [cart, setCart] = useState([]);


   
    const [gstRate, setGstRate] = useState(0);
    
const handleGstRateChange = (event) => {
    setGstRate(event.target.value);
  };

  const handleAddItem = () => {
    const subtotal = price * quantity;
    const newItem = { name: itemName, price: Number(price), quantity: Number(quantity), subtotal };
    setCart([...cart, newItem]);
    setItemName('');
    setPrice('');
    setQuantity(1);
  };

  const handleRemoveItem = (index) => {
    const newCart = [...cart];
    newCart.splice(index, 1);
    setCart(newCart);
  };

const calculateTotal = () => {
  const subtotal = cart.reduce((acc, item) => acc + item.subtotal, 0);
  const gst = subtotal * (gstRate / 100);
  const total = subtotal + gst;
  return { subtotal, gst, total };
};


const generatePdfInvoice = () => {
  const { subtotal, gst, total } = calculateTotal(); // Destructure properly
  const currentDate = new Date().toLocaleDateString();
  const doc = new jsPDF();

  doc.setFontSize(20);
  doc.text(shopName || 'Shop Name', 105, 15, null, null, 'center');
  doc.setFontSize(12);
  doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
  doc.text(`Phone: ${phoneNumber}`, 200, 20, null, null, 'right');
  doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
  doc.text('Invoice', 105, 30, null, null, 'center');

  doc.autoTable({
    startY: 40,
    head: [['Item', 'Price', 'Qty', 'Subtotal']],
    body: cart.map(item => [
      item.name,
      item.price.toFixed(2),
      item.quantity,
      item.subtotal.toFixed(2)
    ])
  });

  doc.autoTable({
    startY: doc.lastAutoTable.finalY + 10,
    body: [
      ['Subtotal', subtotal.toFixed(2)],
      ['GST', gst.toFixed(2)],
      ['Total', total.toFixed(2)]
    ]
  });

  doc.save(`${shopName || 'invoice'}.pdf`);
};


  return (
    <div className="invoice-app">
      <h2>🧾 Simple Invoice</h2>

      <div>
        <label>Shop Name:</label>
        <input value={shopName} onChange={e => setShopName(e.target.value)} />
        <label>GST Number:</label>
        <input value={gstNumber} onChange={e => setGstNumber(e.target.value)} />
        <label>Phone Number:</label>
        <input value={phoneNumber} onChange={e => setPhoneNumber(e.target.value)} />
      </div>

      <div>
        <label>Item Name:</label>
        <input value={itemName} onChange={e => setItemName(e.target.value)} />
        <label>Price:</label>
        <input type="number" value={price} onChange={e => setPrice(e.target.value)} />
        <label>Quantity:</label>
        <input type="number" value={quantity} onChange={e => setQuantity(e.target.value)} min="1" />
        <button onClick={handleAddItem}>➕ Add to Cart</button>
      </div>

      <h3>🛒 Cart</h3>
      {cart.length === 0 ? (
        <p>No items in cart.</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Item</th><th>Price</th><th>Qty</th><th>Subtotal</th><th>❌</th>
            </tr>
          </thead>
          <tbody>
            {cart.map((item, index) => (
              <tr key={index}>
                <td>{item.name}</td>
                <td>{item.price}</td>
                <td>{item.quantity}</td>
                <td>{item.subtotal.toFixed(2)}</td>
                <td><button onClick={() => handleRemoveItem(index)}>Remove</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
<label htmlFor="gst">GST Rate (%)</label>
<select
  id="gst"
  name="gstRate"
  value={gstRate}
  onChange={e => setGstRate(Number(e.target.value))}
>
  <option value="0">0%</option>
  <option value="2.5">2.5%</option>
  <option value="5">5%</option>
  <option value="6">6%</option>
  <option value="9">9%</option>
  <option value="12">12%</option>
  <option value="18">18%</option>
</select>


      <button onClick={generatePdfInvoice}>📄 Generate PDF</button>
    </div>
  );
}

export default SimpleInvoice;
